import { Component, Input } from '@angular/core';

import { AimoRoutingService } from '../../cms-structure/routing/aimo-routing.service';
import { DateUtils } from '../util/date-utils';

@Component({
    selector: 'aimo-closingtime',
    templateUrl: './aimo-closingtime.component.html',
    standalone: false
})
export class AimoClosingtimeComponent {
    @Input() closingTime: Date | string;
    @Input() closingTimeForTheFuture: Date | string;

    constructor(protected aimoRoutingService: AimoRoutingService) {}

    convertDate(d: Date | string): Date {
        return DateUtils.convertDate(d);
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }
}
